import api from './api';

class ProjectTypeService {
    // Get all project types
    static async getAll(page = 1, limit = 100) {
        try {
            const response = await api.get(`/project-types?page=${page}&limit=${limit}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Get project type by ID
    static async getById(id) {
        try {
            const response = await api.get(`/project-types/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Create new project type
    static async create(data) {
        try {
            const response = await api.post('/project-types', data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Update project type
    static async update(id, data) {
        try {
            const response = await api.put(`/project-types/${id}`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Update project type status
    static async updateStatus(id, status) {
        try {
            const response = await api.patch(`/project-types/${id}/status`, { status });
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export default ProjectTypeService;